import React, { forwardRef, useMemo } from 'react';
import { useFormsContext } from '@ally/forms';
import { Label } from '@ally/metronome-ui';
import { withProps } from '@ally/validator';
import validator from './validator';
import TransferAccountSelect from '../../components/TransferAccountSelect';
var FromAccountInput = forwardRef(function (_a, ref) {
    var accounts = _a.accounts, disableAutofill = _a.disableAutofill;
    var values = useFormsContext().values;
    var validate = useMemo(function () { return withProps(validator, { accounts: accounts, values: values }); }, [
        accounts,
        values,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { htmlFor: "fromAccount" }, "From account"),
        React.createElement("div", { "data-testid": "from-account" },
            React.createElement(TransferAccountSelect, { name: "fromAccount", ref: ref, accounts: accounts, prompt: "Select an Account", validate: validate, disableAutofill: disableAutofill }))));
});
export default FromAccountInput;
//# sourceMappingURL=Input.js.map